<template>
    <div>
        <div class="form-group bmd-form-group">
            <label class="bmd-label-floating">Missions {{ type == 'engagees' ? 'engagées' : 'réalisées' }}</label>
            <input id="mission" type="text" v-model="mission" class="form-control">
            <button type="button" @click="addMission" class="btn btn-sm btn-circle btn-icon btn-info">
                <i class="fas fa-plus"></i>
            </button>
            <input type="hidden" :name="`missions_${type}`" v-model="missions">
        </div>
        <div id="missions_list">
            <div class="mission" v-for="m in missionsList" :key="`mission_${m.index}`">
                <p>{{ m.content }}</p>
                <button type="button" :data-index="m.index" @click="deleteMission(m.index)"
                class="btn btn-sm btn-icon btn-danger">
                    <i class="fas fa-trash"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            type: String,
        },
        data() {
            return {
                missions: [],
                missionsList: [],
                mission: null,
                index: 1,
            }
        },

        methods: {
            addMission() {
                this.missionsList.push({
                    index: this.index,
                    content: this.mission,
                });
                this.index += 1;
                this.missions.push(this.mission);
                this.mission = "";
            },
            deleteMission(index) {
                this.missionsList = this.missionsList.filter(m => { return m.index != index });
                this.missions = this.missionsList.map(m => { return m.content });
                this.index -= 1;
            }
        }
    }

</script>

<style scoped>
    .form-group {
        position: relative;
    }

    .form-group button {
        position: absolute;
        right: 0;
        top: -12px;
        min-width: 30px;
        width: 30px;
        height: 30px;
    }

    .form-group .material-icons {
        line-height: 30px;
    }

    #missions_list {
        height: 200px;
        overflow-y: scroll;
    }

    .mission {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .mission p {
        margin: 0;
    }
</style>
